import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Stack from '@mui/material/Stack/Stack';
import Typography from '@mui/material/Typography/Typography';
import Button from '@mui/material/Button/Button';
import Chip from '@mui/material/Chip/Chip';
import Card from '@mui/material/Card/Card';
import CardContent from '@mui/material/CardContent/CardContent';
import { getOrganizationEvents, OrganizationEvent } from '../../services/organization.service';

/**
 * The company's hackathons with their plan, so its branding has a visible home and a Free event can be upgraded from
 * here (Charles, run031: "no way to buy Pro from the company page").
 */
export const OrganizationEvents = ({ organizationId }: { organizationId: string }) => {
    const [events, setEvents] = useState<OrganizationEvent[] | null>(null);

    useEffect(() => {
        getOrganizationEvents(organizationId).then(setEvents, () => setEvents([]));
    }, [organizationId]);

    return (
        <Card>
            <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                <Stack spacing={2}>
                    <div>
                        <Typography variant="h4" component="h2">Hackathons</Typography>
                        <Typography variant="body2" color="text.secondary">The company's look shows on its Pro events. Upgrade a Free one to show it there.</Typography>
                    </div>
                    {
                        events && events.length === 0 && <Stack spacing={1} alignItems="flex-start">
                            <Typography color="text.secondary">No hackathons linked to this company yet.</Typography>
                            <Button variant="contained" component={Link} to="/new">Create a hackathon</Button>
                        </Stack>
                    }
                    {
                        events && events.map(event => (
                            <Stack key={event._id} direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
                                <Typography sx={{ flex: 1, minWidth: 160, overflowWrap: 'anywhere' }}>
                                    <Link to={`/h/${event.slug}`}>{event.name}</Link>
                                </Typography>
                                <Chip size="small" color={event.plan === 'pro' ? 'secondary' : 'default'} variant={event.plan === 'pro' ? 'filled' : 'outlined'}
                                    label={event.plan === 'pro' ? 'Pro: branded' : 'Free: not branded'} />
                                {event.plan !== 'pro' && <Button size="small" component={Link} to={`/h/${event.slug}/upgrade`}>Upgrade</Button>}
                            </Stack>
                        ))
                    }
                </Stack>
            </CardContent>
        </Card>
    );
}
